import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { GameViewMode } from "../enum/game";
import type Game from "../models/game";
import type { Action } from "../models/game/action";
import type { ApiGame } from "../types/apigame";
import type { Rules } from "../types/rule";

export type GameContextType = {
    currentAction?: Action;
    currentActionIndex: number | null;
    currentGameView: ApiGame;
    gameViewMode: GameViewMode;
    gameViewModeOptions: any;
    fogSeatNumber: number | null;
    g: Game;
    game: ApiGame;
    highlightedSeatNumber?: number;
    lastAttackCountry?: number;
    lastSeenChatAction?: number;
    rules: Rules;
    setCurrentAction: (action: Action) => void;
    setCurrentGameView: Dispatch<SetStateAction<ApiGame>>;
    setFogSeatNumber: Dispatch<SetStateAction<number | null>>;
    setGameViewMode: Dispatch<SetStateAction<GameViewMode>>;
    setGame: (game: ApiGame) => void;
    setGameFromOptimizedGame: (oldGame: ApiGame, optimizedGame: ApiGame) => void;
    setGameViewModeOptions: Dispatch<SetStateAction<any>>;
    setHighlightedSeatNumber?: Dispatch<SetStateAction<number>>;
    setLastAttackCountry: (value?: number) => void;
    setLastSeenChatAction: (lastSeenChatAction: number) => void;
    setReplayShouldAutoPlay: (value: boolean) => void;
};

export const GameContext = createContext<GameContextType>({
    currentGameView: null,
    currentActionIndex: null,
    fogSeatNumber: null,
    gameViewMode: null,
    g: null,
    game: null,
    gameViewModeOptions: null,
    highlightedSeatNumber: null,
    lastAttackCountry: null,
    lastSeenChatAction: null,
    rules: null,
    setCurrentAction: (action: Action): void => { },
    setCurrentGameView: (game: ApiGame): void => { },
    setFogSeatNumber: (value: number | null): void => { },
    setGameViewMode: (value: GameViewMode): void => { },
    setGame: (game: ApiGame): void => { },
    setGameFromOptimizedGame: (oldGame: ApiGame, optimizedGame: ApiGame) => { },
    setGameViewModeOptions: (value: any) => { },
    setHighlightedSeatNumber: (varue: number): void => { },
    setLastAttackCountry: (value: number): void => { },
    setLastSeenChatAction: () => { },
    setReplayShouldAutoPlay: () => { },
});

export function useGame() {
    return useContext(GameContext);
}
